<template>
	<DoughnutChart :chart-data="chartdata" :options="options" />
  </template>
  
  <script>
  import { defineComponent } from "vue";
  import { DoughnutChart } from "vue-chart-3";
  import { Chart, registerables } from "chart.js";
  Chart.register(...registerables);
  
  export default defineComponent({
	name: "GraficoEmprestimoCircular",
	components: { DoughnutChart },
  
	props: {
	  dados: {
		type: Object,
		required: true,
	  },
	},
	data() {
	  return {
		percentualPago: 0,
		arrayData: [],
		chartdata: null,
		options: {
		  cutout: "84%", // Ajuste correto para versões mais recentes do Chart.js
		  plugins: {
			legend: {
			  display: false, // Certifique-se de que a legenda está desabilitada
			},
			tooltip: {
			  enabled: false, // Desabilitar tooltips
			},
		  },
		},
	  };
	},
	created() {
	  this.percentualPago = this.dados.data;
	  this.arrayData = [this.percentualPago, 100 - Number(this.percentualPago)];
	},
	mounted() {
	  this.chartdata = {
		labels: ["Pago", "Restante"], // A adição de labels pode evitar o erro do length
		datasets: [
		  {
			data: this.arrayData,
			backgroundColor: ["#cc6600", "#D3D3D3"],
			borderWidth: 1,
			borderColor: "#FFFFFF",
		  },
		],
	  };
	},
  });
  </script>
  